'use strict';

var _asyncToGenerator = require("/vercel/path0/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;
var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass.js").default;
var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;
var _createForOfIteratorHelper = require("/vercel/path0/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js").default;
var _toConsumableArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;
var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
Object.defineProperty(exports, '__esModule', {
  value: true
});
require('./index.js');
var cid = require('./cid.js');
var bytes = require('./bytes.js');
var readonly = function readonly() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$enumerable = _ref.enumerable,
    enumerable = _ref$enumerable === void 0 ? true : _ref$enumerable,
    _ref$configurable = _ref.configurable,
    configurable = _ref$configurable === void 0 ? false : _ref$configurable;
  return {
    enumerable: enumerable,
    configurable: configurable,
    writable: false
  };
};
var _links = /*#__PURE__*/_regeneratorRuntime().mark(function links(source, base) {
  var _i, _Object$entries, _Object$entries$_i, key, value, path, _iterator, _step, _step$value, index, element, elementPath, cid$1, _cid$;
  return _regeneratorRuntime().wrap(function links$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        if (!(source == null)) {
          _context.next = 2;
          break;
        }
        return _context.abrupt("return");
      case 2:
        if (!(source instanceof Uint8Array)) {
          _context.next = 4;
          break;
        }
        return _context.abrupt("return");
      case 4:
        _i = 0, _Object$entries = Object.entries(source);
      case 5:
        if (!(_i < _Object$entries.length)) {
          _context.next = 46;
          break;
        }
        _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
        path = [].concat(_toConsumableArray(base), [key]);
        if (!(value != null && typeof value === 'object')) {
          _context.next = 43;
          break;
        }
        if (!Array.isArray(value)) {
          _context.next = 36;
          break;
        }
        _iterator = _createForOfIteratorHelper(value.entries());
        _context.prev = 11;
        _iterator.s();
      case 13:
        if ((_step = _iterator.n()).done) {
          _context.next = 26;
          break;
        }
        _step$value = _slicedToArray(_step.value, 2), index = _step$value[0], element = _step$value[1];
        elementPath = [].concat(_toConsumableArray(path), [index]);
        cid$1 = cid.CID.asCID(element);
        if (!cid$1) {
          _context.next = 22;
          break;
        }
        _context.next = 20;
        return [elementPath.join('/'), cid$1];
      case 20:
        _context.next = 24;
        break;
      case 22:
        if (!(typeof element === 'object')) {
          _context.next = 24;
          break;
        }
        return _context.delegateYield(_links(element, elementPath), "t0", 24);
      case 24:
        _context.next = 13;
        break;
      case 26:
        _context.next = 31;
        break;
      case 28:
        _context.prev = 28;
        _context.t1 = _context["catch"](11);
        _iterator.e(_context.t1);
      case 31:
        _context.prev = 31;
        _iterator.f();
        return _context.finish(31);
      case 34:
        _context.next = 43;
        break;
      case 36:
        _cid$ = cid.CID.asCID(value);
        if (!_cid$) {
          _context.next = 42;
          break;
        }
        _context.next = 40;
        return [path.join('/'), _cid$];
      case 40:
        _context.next = 43;
        break;
      case 42:
        return _context.delegateYield(_links(value, path), "t2", 43);
      case 43:
        _i++;
        _context.next = 5;
        break;
      case 46:
      case "end":
        return _context.stop();
    }
  }, _links, null, [[11, 28, 31, 34]]);
});
var _tree = /*#__PURE__*/_regeneratorRuntime().mark(function tree(source, base) {
  var _i2, _Object$entries2, _Object$entries2$_i, key, value, path, _iterator2, _step2, _step2$value, index, element, elementPath;
  return _regeneratorRuntime().wrap(function tree$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        if (!(source == null)) {
          _context2.next = 2;
          break;
        }
        return _context2.abrupt("return");
      case 2:
        _i2 = 0, _Object$entries2 = Object.entries(source);
      case 3:
        if (!(_i2 < _Object$entries2.length)) {
          _context2.next = 36;
          break;
        }
        _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2), key = _Object$entries2$_i[0], value = _Object$entries2$_i[1];
        path = [].concat(_toConsumableArray(base), [key]);
        _context2.next = 8;
        return path.join('/');
      case 8:
        if (!(value != null && !(value instanceof Uint8Array) && typeof value === 'object' && !cid.CID.asCID(value))) {
          _context2.next = 33;
          break;
        }
        if (!Array.isArray(value)) {
          _context2.next = 32;
          break;
        }
        _iterator2 = _createForOfIteratorHelper(value.entries());
        _context2.prev = 11;
        _iterator2.s();
      case 13:
        if ((_step2 = _iterator2.n()).done) {
          _context2.next = 22;
          break;
        }
        _step2$value = _slicedToArray(_step2.value, 2), index = _step2$value[0], element = _step2$value[1];
        elementPath = [].concat(_toConsumableArray(path), [index]);
        _context2.next = 18;
        return elementPath.join('/');
      case 18:
        if (!(typeof element === 'object' && !cid.CID.asCID(element))) {
          _context2.next = 20;
          break;
        }
        return _context2.delegateYield(_tree(element, elementPath), "t0", 20);
      case 20:
        _context2.next = 13;
        break;
      case 22:
        _context2.next = 27;
        break;
      case 24:
        _context2.prev = 24;
        _context2.t1 = _context2["catch"](11);
        _iterator2.e(_context2.t1);
      case 27:
        _context2.prev = 27;
        _iterator2.f();
        return _context2.finish(27);
      case 30:
        _context2.next = 33;
        break;
      case 32:
        return _context2.delegateYield(_tree(value, path), "t2", 33);
      case 33:
        _i2++;
        _context2.next = 3;
        break;
      case 36:
      case "end":
        return _context2.stop();
    }
  }, _tree, null, [[11, 24, 27, 30]]);
});
var _get = function get(source, path) {
  var node = source;
  var _iterator3 = _createForOfIteratorHelper(path.entries()),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _step3$value = _slicedToArray(_step3.value, 2),
        index = _step3$value[0],
        key = _step3$value[1];
      node = node[key];
      if (node == null) {
        throw new Error("Object has no property at ".concat(path.slice(0, index + 1).map(function (part) {
          return "[".concat(JSON.stringify(part), "]");
        }).join('')));
      }
      var cid$1 = cid.CID.asCID(node);
      if (cid$1) {
        return {
          value: cid$1,
          remaining: path.slice(index + 1).join('/')
        };
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return {
    value: node
  };
};
var Block = /*#__PURE__*/function () {
  function Block(_ref2) {
    var cid = _ref2.cid,
      bytes = _ref2.bytes,
      value = _ref2.value;
    _classCallCheck(this, Block);
    if (!cid || !bytes || typeof value === 'undefined') throw new Error('Missing required argument');
    this.cid = cid;
    this.bytes = bytes;
    this.value = value;
    this.asBlock = this;
    Object.defineProperties(this, {
      cid: readonly(),
      bytes: readonly(),
      value: readonly(),
      asBlock: readonly()
    });
  }
  _createClass(Block, [{
    key: "links",
    value: function links() {
      return _links(this.value, []);
    }
  }, {
    key: "tree",
    value: function tree() {
      return _tree(this.value, []);
    }
  }, {
    key: "get",
    value: function get() {
      var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
      return _get(this.value, path.split('/').filter(Boolean));
    }
  }]);
  return Block;
}();
var encode = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref3) {
    var value, codec, hasher, bytes, hash, cid$1;
    return _regeneratorRuntime().wrap(function _callee$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          value = _ref3.value, codec = _ref3.codec, hasher = _ref3.hasher;
          if (!(typeof value === 'undefined')) {
            _context3.next = 3;
            break;
          }
          throw new Error('Missing required argument "value"');
        case 3:
          if (!(!codec || !hasher)) {
            _context3.next = 5;
            break;
          }
          throw new Error('Missing required argument: codec or hasher');
        case 5:
          bytes = codec.encode(value);
          _context3.next = 8;
          return hasher.digest(bytes);
        case 8:
          hash = _context3.sent;
          cid$1 = cid.CID.create(1, codec.code, hash);
          return _context3.abrupt("return", new Block({
            value: value,
            bytes: bytes,
            cid: cid$1
          }));
        case 11:
        case "end":
          return _context3.stop();
      }
    }, _callee);
  }));
  return function encode(_x) {
    return _ref4.apply(this, arguments);
  };
}();
var decode = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref5) {
    var bytes, codec, hasher, value, hash, cid$1;
    return _regeneratorRuntime().wrap(function _callee2$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          bytes = _ref5.bytes, codec = _ref5.codec, hasher = _ref5.hasher;
          if (bytes) {
            _context4.next = 3;
            break;
          }
          throw new Error('Missing required argument "bytes"');
        case 3:
          if (!(!codec || !hasher)) {
            _context4.next = 5;
            break;
          }
          throw new Error('Missing required argument: codec or hasher');
        case 5:
          value = codec.decode(bytes);
          _context4.next = 8;
          return hasher.digest(bytes);
        case 8:
          hash = _context4.sent;
          cid$1 = cid.CID.create(1, codec.code, hash);
          return _context4.abrupt("return", new Block({
            value: value,
            bytes: bytes,
            cid: cid$1
          }));
        case 11:
        case "end":
          return _context4.stop();
      }
    }, _callee2);
  }));
  return function decode(_x2) {
    return _ref6.apply(this, arguments);
  };
}();
var createUnsafe = function createUnsafe(_ref7) {
  var bytes = _ref7.bytes,
    cid = _ref7.cid,
    maybeValue = _ref7.value,
    codec = _ref7.codec;
  var value = maybeValue !== undefined ? maybeValue : codec && codec.decode(bytes);
  if (value === undefined) throw new Error('Missing required argument, must either provide "value" or "codec"');
  return new Block({
    cid: cid,
    bytes: bytes,
    value: value
  });
};
var create = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref8) {
    var bytes$1, cid, hasher, codec, value, hash;
    return _regeneratorRuntime().wrap(function _callee3$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          bytes$1 = _ref8.bytes, cid = _ref8.cid, hasher = _ref8.hasher, codec = _ref8.codec;
          if (bytes$1) {
            _context5.next = 3;
            break;
          }
          throw new Error('Missing required argument "bytes"');
        case 3:
          if (hasher) {
            _context5.next = 5;
            break;
          }
          throw new Error('Missing required argument "hasher"');
        case 5:
          value = codec.decode(bytes$1);
          _context5.next = 8;
          return hasher.digest(bytes$1);
        case 8:
          hash = _context5.sent;
          if (bytes.equals(cid.multihash.bytes, hash.bytes)) {
            _context5.next = 11;
            break;
          }
          throw new Error('CID hash does not match bytes');
        case 11:
          return _context5.abrupt("return", createUnsafe({
            bytes: bytes$1,
            cid: cid,
            value: value,
            codec: codec
          }));
        case 12:
        case "end":
          return _context5.stop();
      }
    }, _callee3);
  }));
  return function create(_x3) {
    return _ref9.apply(this, arguments);
  };
}();
exports.Block = Block;
exports.create = create;
exports.createUnsafe = createUnsafe;
exports.decode = decode;
exports.encode = encode;